import { clearToken } from './token.service';
import axios from '../requester';
import { API } from '../constants/api-urls';
import { disconnectPusher } from 'common/services/pusher.service';

export function logOut(redirectTo = '/login') {
  clearToken();
  disconnectPusher();
  window.location = redirectTo;
}

export function gotoOverdue() {
  window.location = '/overdue';
}

export function reauth(payload) {
  return axios.post(`${API.AUTH_PATH}/grant/reauth`, payload, {
    withCredentials: true
  });
}

export function reauthV2(payload) {
  return axios.post(`${API.AUTH_PATH}/grant/reauth/v2`, payload, {
    withCredentials: true
  });
}
